import React, {useState} from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {makeStyles} from '@material-ui/core/styles'

import TrackAddDialog from '../TrackAddDialog';

const TrackItem = ({
                       performingAction, description, handleDescriptionChange, handleTrackUrlChange, handleAddTrackFile,
                       trackFile, moveTrack, trackUrl, setTrackUrl, playCurrentAudio, pauseCurrentAudio,
                       getTrackTimestamRepresent, trackTimespan, trackType
                   }) => {
    const classes = useStyles();
    const [isAddTrackDialogVisible, setIsAddTrackDialogVisible] = useState(false);

    const addTrackDialogVisibilityHandler = () => {
        setIsAddTrackDialogVisible(!isAddTrackDialogVisible);
    }

    return (
        <>
            <TextField
                disabled={!performingAction}
                label={trackType === 'day' ? 'Описание дневного трека' :
                    trackType === 'night' ? 'Описание ночного трека' : ''}
                required
                type='text'
                value={description}
                helperText={description === '' ? 'Не указано' : ''}
                className={classes.textField}
                multiline
                onChange={handleDescriptionChange}
            />
            <TextField
                disabled={!performingAction}
                label={trackType === 'day' ? 'URL дневного трека' :
                    trackType === 'night' ? 'URL ночного трека' : ''}
                required
                type='text'
                value={trackUrl}
                className={classes.textField}
                multiline
                onChange={handleTrackUrlChange}
            />
            <div>
                <Button
                    className={classes.uploadButton}
                    onClick={addTrackDialogVisibilityHandler}
                >
                    Загрузить трек
                </Button>
                <Button onClick={() => moveTrack(trackUrl, description, setTrackUrl)}>Переместить трек</Button>
                <Button onClick={playCurrentAudio}>Play</Button>
                <Button onClick={pauseCurrentAudio}>Stop</Button>
            </div>
            <audio src={trackFile.name || ''}/>
            <TextField
                label={trackType === 'day' ? 'Длительность дневного трека' :
                    trackType === 'night' ? 'Длительность ночного трека' : ''}
                disabled
                type='text'
                value={getTrackTimestamRepresent()}
                className={classes.textField}
                helperText={
                    trackTimespan === '00:00:00'
                        ? '(пока аудио не загружено)'
                        : ''
                }
            />
            <TrackAddDialog
                open={isAddTrackDialogVisible}
                handleClose={addTrackDialogVisibilityHandler}
                handleAddTrackFile={handleAddTrackFile}
                trackType={trackType}
            />
        </>
    );
}

const useStyles = makeStyles({
    textField: {
        width: '300px',
        marginTop: '5px'
    },
    input: {
        display: 'none'
    },
    uploadButton: {
        marginTop: '5px',
        marginRight: '5px',
        marginBottom: '5px'
    }
})

export default TrackItem;
